
export const SurveyQuestionDisplayTypes = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
  DROPDOWN: 'DROPDOWN',
  RATING: 'RATING'
};
